import HeroComponent from '../components/hero';

export default class BlogListingController {

  constructor(options) {
    this.options = options;
    console.log('BLOG LISTING CONTROLLER');

    this.blog_hero = new HeroComponent({
      elem          :'section.blog__hero',
      parallaxCopy  : true,
    });

    $('nav.siteNav__main div.siteNav__main__subpages a.siteNav__main__subpages__blog').addClass('is-activepage');

    this.transitionIn();

  }

  transitionIn() {
    console.log('HERE!');
    // reveal the home hero text
    $('.blog__hero .cmpnt__hero__copy__cntr').addClass('do-intro');

    setTimeout( () => {
      console.log('HERE!!!');
      $('.blog__hero .cmpnt__hero__copy__cntr').removeClass('do-intro start-intro');
    }, 2300);

  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/BlogListingController.js